import React from 'react';
import './main.scss';

import NavTop from './navtop/NavTop';

class AppComponent extends React.Component {
  constructor(props) {
    super(props);

    this.authService = this.props.authService;

    this.state = {
      authenticated: this.authService.authenticated(),
      userProfile: this.authService.getUserProfile()
    };

    this.login = this.authService.login.bind(this);
    this.logout = this.authService.logout.bind(this);
  }

  componentDidMount() {
    const vm = this;

    // Hack to sync Auth Service authenticated state with top level component
    window.addEventListener('authchange', () => {
      vm.setState(Object.assign({}, vm.state, {
        authenticated: vm.authService.authenticated(),
        userProfile: vm.authService.getUserProfile()
      }));
    });
  }

  componentWillUnMount() {
    window.removeEventListener('authchange');
  }

  render() {
    return (
      <NavTop login={this.login}
        logout={this.logout}
        authenticated={this.state.authenticated}
        userProfile={this.state.userProfile || {}}
        authService={this.authService}
      />
    );
  }
}

export default AppComponent;
